import * as React from "react";
const SvgFiRrUserSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-slash_svg__a)">
      <path
        fill="#062147"
        d="M10.968 15.003a1 1 0 0 1-.719 1.217A6.996 6.996 0 0 0 5 23a1 1 0 0 1-2 0 8.995 8.995 0 0 1 6.75-8.716 1 1 0 0 1 1.218.72zm12.74 8.704a.997.997 0 0 1-1.415 0l-22-22A.999.999 0 1 1 1.707.293L6.14 4.725C6.726 2.028 9.13 0 12 0c3.31 0 6 2.691 6 6 0 2.871-2.028 5.274-4.725 5.861l10.432 10.432a1 1 0 0 1 0 1.414M8.064 6.651l3.284 3.284c.215.035.432.065.651.065 2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4c0 .218.03.436.065.651"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserSlash;
